import { useEffect, useState } from "react";
import { AnimatePresence, motion as Motion } from "motion/react";
import AccessGateway from "./components/AccessGateway/AccessGateway";
import RegistrationFlow from "./components/RegistrationFlow/RegistrationFlow";
import Success from "./components/Success/Success";
import { SCREEN_MOTION } from "./config/screenMotion";
import { isCompanionRestricted } from "./data/companionRestrictions";
import { mapRegistrationToForm } from "./services/registrationData";
import { trackPageView } from "./utils/analytics";
import desktopBanner from "./assets/images/header-hotsite.png";
import mobileBanner from "./assets/images/header-hotsite-mobile-crop-18.png";
import styles from "./App.module.scss";

const BRAND_PANEL = (
  <header className={styles.brandPanel}>
    <picture>
      <source media="(max-width: 600px)" srcSet={mobileBanner} />
      <img
        className={styles.brandBanner}
        src={desktopBanner}
        alt="Grande Prêmio de São Paulo 2026 — Programa de Excelência Shell"
        fetchPriority="high"
      />
    </picture>
  </header>
);

const ANALYTICS_SCREENS = {
  login: { path: "/", title: "Acesso | Grande Prêmio de São Paulo 2026" },
  registration: { path: "/cadastro", title: "Cadastro | Grande Prêmio de São Paulo 2026" },
  success: { path: "/cadastro-concluido", title: "Cadastro concluído | Grande Prêmio de São Paulo 2026" },
};

function App() {
  const [screen, setScreen] = useState("login");
  const [registrationData, setRegistrationData] = useState(null);
  const [companionRestricted, setCompanionRestricted] = useState(false);

  useEffect(() => {
    const analyticsScreen = ANALYTICS_SCREENS[screen];
    trackPageView(analyticsScreen.path, analyticsScreen.title);
  }, [screen]);

  const openAuthenticatedRegistration = (data, credentials) => {
    setRegistrationData(mapRegistrationToForm(data));
    setCompanionRestricted(isCompanionRestricted(credentials?.ibm ?? data?.ibmposto ?? data?.ibm));
    setScreen("registration");
  };

  const openLogin = () => {
    setRegistrationData(null);
    setCompanionRestricted(false);
    setScreen("login");
  };

  return (
    <main id="cadastro" className={styles.page} tabIndex="-1">
      {BRAND_PANEL}
      <div className={styles.formPanel}>
        <AnimatePresence mode="wait" initial={false}>
          <Motion.div
            key={screen}
            {...SCREEN_MOTION}
          >
            {screen === "login" ? <AccessGateway onLogin={openAuthenticatedRegistration} /> : null}
            {screen === "registration" ? <RegistrationFlow initialData={registrationData} companionRestricted={companionRestricted} onComplete={() => setScreen("success")} onLogin={openLogin} /> : null}
            {screen === "success" ? <Success onBack={openLogin} /> : null}
          </Motion.div>
        </AnimatePresence>
      </div>
    </main>
  );
}

export default App;
